import { FC } from 'react';
import { Content } from '@prismicio/client';
import {
  CaliforniaPolicyTable,
  DefaultTable,
  EqualTable,
  FourColumnsTable,
  OnToTwoTable,
  OnToTwoTableSecondary,
  ThreeColumnsTable,
} from '@/components';

type Props = {
  slice: Content.PolicyTableSlice;
};

export const PolicyTableInner: FC<Props> = ({ slice }) => {
  switch (slice.variation) {
    case 'default':
      return <DefaultTable data={slice.primary} />;
    case 'threeColumns':
      return <ThreeColumnsTable data={slice.primary} />;
    case 'equal':
      return <EqualTable data={slice.primary} />;
    case 'onToTwo':
      return <OnToTwoTable data={slice.primary} />;
    case 'onToTwoSecondary':
      return <OnToTwoTableSecondary data={slice.primary} />;
    case 'californiaPolicy':
      return <CaliforniaPolicyTable data={slice.primary} />;
    case 'fourColumns':
      return <FourColumnsTable data={slice.primary} />;
    default:
      return <></>;
  }
};
